import _ from "lodash";

export function generateUniqueId(toString, subString1, subString2) {
  return `${Date.now()}-${Math.random()
    .toString(toString)
    .substring(subString1, subString2)}`;
}

export function htmlDecode(input) {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.documentElement.textContent;
}

export const ellipsisLast = (data, limit = 1, fromWhere = "last") => {
  if (data && data.length > limit) {
    if (fromWhere === "last") {
      return `${data.substring(0, limit)}...`;
    }
    if (fromWhere === "start") {
      return `...${data.substring(data.length - limit, limit)}`;
    }
  }
  return data;
};

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

async function handleAllImagesUpLoad(file) {
  const base64 = await convertToBase64(file);
  const base642 = base64.split(',');
  return base642[1];
}
export default handleAllImagesUpLoad

export const urlForInputFile = (file) => URL.createObjectURL(file)


export function getRandomColor() {
  let letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const getFirstLetterFromName = (name) => {
  if (name) {
    const splitName = _.split(_.trim(name), ' ')
    if (!_.isEmpty(splitName)) {
      const words = _.map(splitName, l => l.charAt(0).toUpperCase()).join('')
      return words
    }
    return ''
  }
}